import React from 'react';
import Banner from '../components/career/banner';
import Poster from '../components/career/poster'

function careerpage() {
  return (
    <div>
        <Banner/>
        <Poster/>
    </div>
  )
}

export default careerpage